import {useEffect, useState} from "react";

import {RequestState} from "@pg-mono/request-state";

import {fetchRegionAveragePrice, IFetchRegionAveragePriceParams, ISelectedRegionAveragePrices} from "../api/fetch_region_average_price";

interface IRegionAveragePriceParams extends IFetchRegionAveragePriceParams {
    roomsCount: number;
}

export const useRegionAveragePriceByRooms = (params: IRegionAveragePriceParams) => {
    const [requestState, setRequestState] = useState<RequestState>(RequestState.None);
    const [regionAveragePriceRaw, setRegionAveragePriceRaw] = useState<ISelectedRegionAveragePrices[]>([]);
    const [regionAveragePriceByRooms, setRegionAveragePriceByRooms] = useState<number>(0);
    const [regionAverageMinByRooms, setRegionAverageMinByRooms] = useState<number>(0);
    const [regionAverageMaxByRooms, setRegionAverageMaxByRooms] = useState<number>(0);

    const neededParam = roomsNumberToParam(params.roomsCount);

    useEffect(() => {
        setRequestState(RequestState.Waiting);
        fetchRegionAveragePrice(params)
            .then((response) => {
                setRegionAveragePriceRaw(response);
                if (response.length > 0) {
                    const latestPrices = response[response.length - 1];
                    const avgPricesByRooms = response.map((item) => item[neededParam]).filter(Boolean);

                    setRegionAveragePriceByRooms(latestPrices[neededParam] || latestPrices.avg_price);
                    setRegionAverageMinByRooms(Math.min(...avgPricesByRooms));
                    setRegionAverageMaxByRooms(Math.max(...avgPricesByRooms));
                }
                setRequestState(RequestState.Success);
            })
            .catch(() => {
                setRegionAveragePriceRaw([]);
                setRegionAveragePriceByRooms(0);
                setRegionAverageMinByRooms(0);
                setRegionAverageMaxByRooms(0);
                setRequestState(RequestState.Error);
            });
    }, [params.region]);

    return {
        requestState,
        regionAveragePriceRaw,
        regionAveragePriceByRooms,
        regionAverageMinByRooms,
        regionAverageMaxByRooms
    };
};

const roomsNumberToParam = (roomsNumber: number) => {
    if (roomsNumber === 1) {
        return "avg_price_studio";
    }
    if (roomsNumber === 2) {
        return "avg_price_2_rooms";
    }
    if (roomsNumber === 3) {
        return "avg_price_3_rooms";
    }
    if (roomsNumber >= 4) {
        return "avg_price_4_plus_rooms";
    }
    return "avg_price";
};
import {useEffect, useState} from "react";

import {RequestState} from "@pg-mono/request-state";

import {fetchRegionAveragePrice, IFetchRegionAveragePriceParams, ISelectedRegionAveragePrices} from "../api/fetch_region_average_price";

interface IRegionAveragePriceParams extends IFetchRegionAveragePriceParams {
    roomsCount: number;
}

export const useRegionAveragePriceByRooms = (params: IRegionAveragePriceParams) => {
    const [requestState, setRequestState] = useState<RequestState>(RequestState.None);
    const [regionAveragePriceRaw, setRegionAveragePriceRaw] = useState<ISelectedRegionAveragePrices[]>([]);
    const [regionAveragePriceByRooms, setRegionAveragePriceByRooms] = useState<number>(0);
    const [regionAverageMinByRooms, setRegionAverageMinByRooms] = useState<number>(0);
    const [regionAverageMaxByRooms, setRegionAverageMaxByRooms] = useState<number>(0);

    const neededParam = roomsNumberToParam(params.roomsCount);

    useEffect(() => {
        setRequestState(RequestState.Waiting);
        fetchRegionAveragePrice(params)
            .then((response) => {
                setRegionAveragePriceRaw(response);
                if (response.length > 0) {
                    const latestPrices = response[response.length - 1];
                    const avgPricesByRooms = response.map((item) => item[neededParam]).filter(Boolean);

                    setRegionAveragePriceByRooms(latestPrices[neededParam] || latestPrices.avg_price);
                    setRegionAverageMinByRooms(Math.min(...avgPricesByRooms));
                    setRegionAverageMaxByRooms(Math.max(...avgPricesByRooms));
                }
                setRequestState(RequestState.Success);
            })
            .catch(() => {
                setRegionAveragePriceRaw([]);
                setRegionAveragePriceByRooms(0);
                setRegionAverageMinByRooms(0);
                setRegionAverageMaxByRooms(0);
                setRequestState(RequestState.Error);
            });
    }, [params.region]);

    return {
        requestState,
        regionAveragePriceRaw,
        regionAveragePriceByRooms,
        regionAverageMinByRooms,
        regionAverageMaxByRooms
    };
};

const roomsNumberToParam = (roomsNumber: number) => {
    if (roomsNumber === 1) {
        return "avg_price_studio";
    }
    if (roomsNumber === 2) {
        return "avg_price_2_rooms";
    }
    if (roomsNumber === 3) {
        return "avg_price_3_rooms";
    }
    if (roomsNumber >= 4) {
        return "avg_price_4_plus_rooms";
    }
    return "avg_price";
};
